import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { IActiveFilterData } from "@/data/filters";
import { FloatedList } from "@/eworkitComponents";
import { useToggle } from "@/hooks/Toggle";

import { FilterBadge } from "../FilterBadge";

interface Props {
  onClearFilters?: () => void;
  activeFilters: IActiveFilterData[];
}

const FiltersActiveFiltersComponent: React.FC<Props> = ({ activeFilters, onClearFilters }) => {
  const { t } = useTranslation("common");
  const [moreVisibility, toggleVisibility] = useToggle(false);

  return (
    <FloatedList align="center">
      {activeFilters.slice(0, moreVisibility ? activeFilters.length : 5).map((filter, i) => (
        <FilterBadge key={i} rightIcon="close" onClick={filter.clearFilter} {...filter} />
      ))}

      {!moreVisibility && activeFilters.length > 5 && (
        <FilterBadge
          label={t("COMPONENTS.FILTERS_CONTAINER.SHOW_MORE", { value: activeFilters.length - 5 })}
          onClick={toggleVisibility}
          rightIcon="dropdown"
        />
      )}

      {moreVisibility && activeFilters.length > 5 && (
        <FilterBadge
          label={t("COMPONENTS.FILTERS_CONTAINER.SHOW_LESS")}
          onClick={toggleVisibility}
          rightIcon="dropdown"
        />
      )}

      {onClearFilters && (
        <Button size="md" variant="link" onClick={onClearFilters}>
          {t("COMPONENTS.FILTERS_CONTAINER.BUTTON_CLEAR_FILTERS")}
        </Button>
      )}
    </FloatedList>
  );
};

export const FiltersActiveFilters = React.memo(FiltersActiveFiltersComponent);
